// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "ion-range{--bar-background: #e6e6e6;--bar-background-active: #d3a966}", "",{"version":3,"sources":["webpack://./src/components/PromoteDialog/style.scss"],"names":[],"mappings":"AAAA,UACE,yBAAA,CACA,gCAAA","sourcesContent":["ion-range {\n  --bar-background: #e6e6e6;\n  --bar-background-active: #d3a966;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
